export { default } from '../[brandSlug]/artikelen/[slug]';
